// extracted by mini-css-extract-plugin
export var aboveInput = "_jk-0";
export var actionButton = "_jk-5";
export var actionButtonContainer = "_jk-1";
export var actionIcon = "_jk-6";
export var aiInfoContainer = "_jk-2";
export var attachmentWrapper = "_jk-7";
export var bold = "_jk-3";
export var checkIcon = "_jk-8";
export var clickingRecipientBar = "_jk-11";
export var commentThreadSwitch = "_jk-a";
export var draftImage = "_jk-b";
export var draftImageContainer = "_jk-c";
export var draftImages = "_jk-e";
export var editButton = "_jk-g";
export var editor = "_jk-f";
export var editorContainer = "_jk-y";
export var editorErrorTooltipWrapper = "_jk-9";
export var headerDivider = "_jk-h";
export var icon = "_jk-i";
export var info = "_jk-j";
export var internal = "_jk-n";
export var internalDivider = "_jk-k";
export var internalMessage = "_jk-l";
export var messageInputCard = "_jk-m";
export var messageInputForm = "_jk-o";
export var messageInputFormInternal = "_jk-p";
export var options = "_jk-q";
export var publicMessageCustomer = "_jk-s";
export var publicMessageMerchant = "_jk-r";
export var removeImageButton = "_jk-d";
export var replyButtons = "_jk-t";
export var showSignatureButton = "_jk-u";
export var spinner = "_jk-v";
export var verticalButtonDivider = "_jk-4";
export var visibilitySelector = "_jk-w";
export var warning = "_jk-x";
export var wrappingText = "_jk-z";
export var writingInternalNoteTopBorder = "_jk-10";